<template>
    <section class="site-fence">
        <div class="layout system-setting-layout my_main">
            <div v-show="showMap" class="system-setting">
                <div class="layout-header regional-header pb0 my_container" ref="searchBox">
                    <div class="infor-layout-header mb16">
                        <span class="title">站点围栏绘制</span>
                        <p>
                            <!-- <el-button type="primary" size="small" @click="onAdd">添加区域</el-button> -->
                        </p>
                    </div>
                    <div class="flex-center-between">
                        <el-form :inline="true" :model="formSearch" class="demo-form-inline">
                            <el-form-item label="站点名称">
                                <el-input class="w120px" v-model="formSearch.siteName" :size="size"
                                          placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item label="站点编号">
                                <el-input class="w120px" v-model="formSearch.siteId" :size="size"
                                          placeholder=""></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" :size="size" @click="onSearch" style="background-color: #3e7878;border-color: #3e7878">查询</el-button>
                                <el-button :size="size" @click="onReset">重置</el-button>
                            </el-form-item>
                        </el-form>
                        <div class="flex-right-area">
<!--                            <el-button :size="size" @click="onAdd('添加区域', 'formAdd')">系统生成</el-button>-->
<!--                            <el-button type="primary" :size="size" @click="onAdd">添加站点围栏</el-button>-->
                        </div>
                    </div>
                    <div class="site-fence-contant">
                        <el-table height="100%" width="100%" :data="dataList">
                            <el-table-column prop="siteName" label="站点名称">
                                <template slot-scope="scope">
                                    <div class="site_name_box">
                                        {{scope.row.siteName}}
                                        <div v-if="scope.row.isCenter" class="is_center">中心点</div>
                                    </div>

                                </template>
                            </el-table-column>
                            <el-table-column prop="siteId" label="站点编号"></el-table-column>
                            <el-table-column prop="siteBikeCeiling" label="车位数"></el-table-column>
                            <el-table-column prop="siteName" label="操作">
                                <template slot-scope="scope">
                                    <div class="handle_box">
                                        <el-button v-if="!scope.row.isCenter" @click="setSiteCenter(scope.row.siteId)"
                                                   type="text">设置中心点
                                        </el-button>
                                        <div v-if="!scope.row.isCenter && scope.row.gpsRail" class="vertical_line"></div>
                                        <el-button type="text" v-if="scope.row.gpsRail" @click="modifyWl(scope.row)">修改</el-button>
                                        <el-button type="text" v-if="!scope.row.gpsRail" @click="onAdd(scope.row)">添加站点围栏</el-button>
                                        <div class="vertical_line" v-if="scope.row.gpsRail"></div>
                                        <el-button type="text" v-if="scope.row.gpsRail" @click="deleteWl(scope.row)">删除</el-button>
                                    </div>

                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
            <div v-show="!showMap" class="map_container">
                <div id="my_chart"></div>
                <div class="right_box">
                    <div class="right_box_title">添加站点</div>
                    <div class="right_box_main">
                        <div class="right_box_main_item">
                            <div class="right_box_main_item_label">站点名称：</div>
                            <div class="right_box_main_item_value">
                                <el-input v-model="chooseEditSite.siteName" size="mini" placeholder="请填写"
                                          style="width:90%;"></el-input>
                            </div>
                        </div>
                        <div class="right_box_main_item">
                            <div class="right_box_main_item_label">站点编号：</div>
                            <div class="right_box_main_item_value">
                                <el-input v-model="chooseEditSite.siteId" size="mini" placeholder="请填写"
                                          style="width:90%;"></el-input>
                            </div>
                        </div>
                        <div class="right_box_main_item">
                            <div class="right_box_main_item_label">车位数：</div>
                            <div class="right_box_main_item_value">
                                <el-input v-model="chooseEditSite.siteBikeCeiling" size="mini" placeholder="请填写"
                                          style="width:90%;"></el-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="map_handle_box">
                    <div class="title">绘制站点围栏</div>
                    <div class="map_handles">
                        <div class="map_handle" :disabled="beginChartStatus" @click="beginChart">绘制多边形</div>
                        <div class="map_handle" @click="beginEditChart">开始编辑</div>
                        <div class="map_handle" @click="endEditChart">结束编辑</div>
                        <div class="map_handle" @click="clearPolygon">清除</div>
                    </div>
                </div>
                <div class="click_btn">
                    <el-button size="small" type="primary" @click="makeSureNewSite">{{isEdit ? '保存' : '添加'}}</el-button>
                    <el-button size="small" @click="cancelNewSite">取消</el-button>
                </div>
            </div>
        </div>
        <!-- 一级弹窗 -->
        <!--        <w-dialog-->
        <!--                width="100%"-->
        <!--                ref="w-dialog"-->
        <!--                :title="dialogTitle"-->
        <!--                sureBtnText="添加"-->
        <!--                @handleCloseRight="onRightClose"-->
        <!--                @handleClose="onClose"-->
        <!--                @onSure="onSure">-->
        <!--            <template v-slot:content>-->
        <!--                <div v-if="type === 'formAdd'">-->
        <!--                    <div>watson</div>-->
        <!--                </div>-->
        <!--            </template>-->
        <!--        </w-dialog>-->
    </section>
</template>

<script>
  import Api from '@/api'
  // import Amap from './index.vue'
  import WDialog from '@/components/Model/index.vue'
  import {
    mapGetters
  } from 'vuex'
  var map = null
  var _this = null
  var polyEditor = null
  var polygon = null
  export default {
    name: 'site-fence',
    data() {
      return {
        showMap: true,
        size: 'small',
        formSearch: {
          siteName: ''
        },
        centerSite: {},
        chooseEditSite: {},
        dataList: [],
        isEdit: false,


        pointArr: [], // 记录绘制的坐标
        beginChartStatus: false,
      }
    },
    mounted() {
      _this = this
      this.getRailList()

    },
    computed: {
      ...mapGetters(['selfAreaId']),
    },
    methods: {
      makeSureNewSite() {
        console.log(_this.siteId)
        let data = {
          siteId: _this.chooseEditSite.siteId,
          gpsRail: JSON.stringify(_this.pointArr),
        }
        let params = {
          selfAreaId: _this.selfAreaId,
          areaId: _this.selfAreaId,

        }
        Api.addSiteArea(data, params).then(res => {
          console.log(res)
          if (res.code === 200) {
            _this.showMap = true
            _this.chooseEditSite.siteName = ''
            _this.chooseEditSite.siteId = ''
            _this.chooseEditSite.siteBikeCeiling = '';
            _this.pointArr = [];
            _this.getRailList();
          } else {
            this.$message.warning(res && res.message)
          }
        }).catch(e => {
          console.log(e)
        })
      },
      cancelNewSite() {
        _this.showMap = true
        _this.chooseEditSite = {}
        _this.chooseEditSite.siteName = ''
        _this.chooseEditSite.siteId = ''
        _this.chooseEditSite.siteBikeCeiling = '';
        _this.clearPolygon()
      },
      // 开始绘制
      beginChart() {
        if (!this.beginChartStatus) {
          this.beginChartStatus = true
        }


        console.log(this.beginChartStatus)
      },
      beginEditChart() {
        polyEditor && polyEditor.open()
      },
      endEditChart() {
        polyEditor && polyEditor.close()
      },
      clearPolygon() {
        polygon && polygon.hide();
        this.pointArr = [];
      },

      initData() {
      },
      makeEnclosure(pointList) {
        var path = []

        for (let i of pointList)  {
          path.push(new AMap.LngLat(i.lon, i.lat))
        }

        polygon = new AMap.Polygon({
          path: path,
          strokeColor: '#FF33FF',
          strokeWeight: 6,
          strokeOpacity: 0.2,
          fillOpacity: 0.4,
          fillColor: '#1791fc',
          zIndex: 50,
        })

        // 初始化围栏
        _this.pointArr = [];
        var b = polygon.getPath();
        for(var d = 0; d < b.length; d++) {
          _this.pointArr.push({
            lat: parseFloat(b[d]['lat']),
            lon: parseFloat(b[d]['lon'])
          })
        }
        //
        //
        var m3 = new AMap.Marker({
          position: [_this.chooseEditSite.siteLon, _this.chooseEditSite.siteLat],
        });
        map.add(polygon)
        map.setFitView([polygon, m3])
        polyEditor = new AMap.PolyEditor(map, polygon)

        polyEditor.on('addnode', function (event) {
        })

        polyEditor.on('adjust', function (event) {
        })

        polyEditor.on('removenode', function (event) {
        })

        polyEditor.on('end', function (event) {
          _this.pointArr = []
          // event.target 即为编辑后的多边形对象
          console.log(event.target.getPath(), '--event.target---')
          var a = event.target.getPath();
          for(var q = 0; q < a.length; q++) {
            _this.pointArr.push({
              lat: parseFloat(a[q]['lat']),
              lon: parseFloat(a[q]['lng'])
            })
          }
          console.log(_this.pointArr, '--_this.pointArr--')
        })
      },
      getRailList() {
        let params = {
          selfAreaId: this.selfAreaId,
          areaId: this.selfAreaId,
        }
        Api.getSiteList(params).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.dataList = res.data

            let markerArr = []
            this.centerSite = res.data.forEach(site => {
              var obj = new AMap.Marker({
                position: new AMap.LngLat(site.siteLon, site.siteLat),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                title: site.siteName
              })

              markerArr.push(obj)
              if (site.isCenter) {
                this.centerSite = site
              }
            })
            if (!this.centerSite) {
              this.centerSite = res.data[0]
            }
            map = new AMap.Map('my_chart', {
              resizeEnable: true, // 允许缩放
              center: [this.centerSite.siteLon, this.centerSite.siteLat], // 设置地图的中心点
              zoom: 15 　　　　　　 // 设置地图的缩放级别，0 - 20
            })
            // this.initData();
            map.add(markerArr)

            map.on('click', function (ev) {
              console.log('您在[ ' + ev.lnglat.getLng() + ',' + ev.lnglat.getLat() + ' ]的位置点击了地图！')
              // 触发事件的对象
              if (!(_this.pointArr && _this.pointArr.length)) {

                // 已经点击了绘制的情况下，会给地图当前位置创建一个默认图层
                // 多边形轮廓线的节点坐标数组
                let lng = ev.lnglat.getLng()
                let lat = ev.lnglat.getLat()
                var path = [
                  new AMap.LngLat(lng, lat),
                  new AMap.LngLat(lng + 0.005, lat),
                  new AMap.LngLat(lng + 0.005, lat + 0.001),
                  new AMap.LngLat(lng, lat + 0.001),
                ]

                polygon = new AMap.Polygon({
                  path: path,
                  strokeColor: '#FF33FF',
                  strokeWeight: 6,
                  strokeOpacity: 0.2,
                  fillOpacity: 0.4,
                  fillColor: '#1791fc',
                  zIndex: 50,
                })

                // 初始化围栏
                _this.pointArr = [];
                var b = polygon.getPath();
                for(var d = 0; d < b.length; d++) {
                  _this.pointArr.push({
                    lat: parseFloat(b[d]['lat']),
                    lon: parseFloat(b[d]['lng'])
                  })
                }


                map.add(polygon)
                map.setFitView([polygon])
                polyEditor = new AMap.PolyEditor(map, polygon)

                polyEditor.on('addnode', function (event) {
                })

                polyEditor.on('adjust', function (event) {
                })

                polyEditor.on('removenode', function (event) {
                })

                polyEditor.on('end', function (event) {
                  _this.pointArr = []
                  // event.target 即为编辑后的多边形对象
                  console.log(event.target.getPath(), '--event.target---')
                  var a = event.target.getPath();
                  for(var q = 0; q < a.length; q++) {
                    _this.pointArr.push({
                      lat: parseFloat(a[q]['lat']),
                      lon: parseFloat(a[q]['lng'])
                    })
                  }
                  console.log(_this.pointArr, '--_this.pointArr--')
                })
                _this.beginChartStatus = false
              } else {
                _this.$message.warning('一次仅能创建一个围栏')
              }
            })

          } else {
            _this.$message.warning(res && res.message)
          }
        }).catch(e => {
          console.log(e)
        })
      },
      setSiteCenter(siteId) {
        let params = {
          selfAreaId: this.selfAreaId,
          areaId: this.selfAreaId,
          siteId: siteId
        }
        Api.putAreaCenter(params).then(res => {
          console.log(res)
          if (res.code === 200) {
            this.getRailList()
          } else {
            this.$message.warning(res && res.message)
          }
        })
      },
      // 事件处理区
      onSearch() {
        this.getRailList()
      },
      onReset() {
        this.formSearch.siteName = ''
        this.formSearch.siteId = ''
        this.onSearch()
      },
      onAdd(row) {
        this.showMap = false;
        this.isEdit = false;
        map.setCenter([row.siteLon, row.siteLat]); //设置地图中心点
      },
      modifyWl(row) {
        console.log(row)
        this.showMap = false;
        this.isEdit = true;
        this.chooseEditSite = row;
        // 生成围栏区域
        map.setCenter([row.siteLon, row.siteLat]); //设置地图中心点
        this.makeEnclosure(JSON.parse(row.gpsRail))

      },
      deleteWl(row) {
        console.log(row.siteId)
        let data = {
          siteId: row.siteId,
          gpsRail: null,
        }
        let params = {
          selfAreaId: _this.selfAreaId,
          areaId: _this.selfAreaId,
        }
        Api.addSiteArea(data, params).then(res => {
          console.log(res)
          if (res.code === 200) {
           // 删除成功
            this.$message.success('删除成功')
            this.getRailList()
          } else {
            this.$message.warning(res && res.message)
          }
        }).catch(e => {
          console.log(e)
        })
      },
      // 弹窗处理
      onRightClose() {
        this.onClose()
      },
      onClose() {
        console.log(this.$refs['w-dialog'])
        this.$refs['w-dialog'].onCloseDialog()
        this.clearFormDate()
      },
      clearFormDate() {
      },
      // beforeDestroy(to, from, next) {
      //   console.log('销毁钱')
      //   this.showMap = true;
      // },
      onSure() {

      },
      // 数据处理
      handleAdd() {
        this.onClose()
      }
    },
    components: {
      WDialog,
    },
    watch: {
      showMap(val) {
        console.log(val)
        // if (!val) {
        //   var map = new AMap.Map('myChart');
        // }
      }
    },
  }
</script>

<style lang="less" scoped>
    .my_main {
        height: calc(100% - 130px);

        .map_container {
            height: 100%;
            display: flex;
            position: relative;
            flex-direction: column;
            justify-content: space-between;

            .map_handle_box {
                position: absolute;
                border-radius: 5px;
                right: 340px;
                bottom: 50px;
                width: 124px;
                height: 180px;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: center;
                background: #fff;
                box-sizing: border-box;
                padding: 10px;

                .map_handles {
                    margin-top: 10px;

                    .map_handle {
                        cursor: pointer;
                        border-radius: 12px;
                        border: 1px solid #1F8FFB;
                        color: #1F8FFB;
                        padding: 2px 5px;
                        text-align: center;
                        margin-bottom: 10px;
                    }
                }
            }

            .right_box {
                position: absolute;
                border: 1px solid #D9D9D9;
                right: 0;
                top: 0;
                height: 100%;
                background: #fff;
                width: 280px;
                padding: 16px;

                .right_box_title {
                    margin-bottom: 20px;
                }

                .right_box_main_item {
                    margin-bottom: 10px;

                    &_label {
                        margin-bottom: 5px;
                    }
                }
            }

            #my_chart {
                width: 100%;

                flex: 1;
                /*height: calc(100% - 100px);*/
            }

            .click_btn {
                display: flex;
                background: #fff;
                flex-direction: row;
                justify-content: center;
            }
        }

    }

    .my_container {
        display: flex;
        height: 100%;
        flex-direction: column;

        .site-fence-contant {
            font-size: 14px;
            flex: 1;

            .site_name_box {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
            }

            .is_center {
                color: #1890FF;
                margin-left: 5px;
                border: 1px solid #1890FF;
                border-radius: 5px;
                font-size: 12px;
                height: 18px;
                line-height: 18px;
                padding: 0 5px;
            }

            .handle_box {
                display: flex;
                flex-direction: row;
                justify-content: space-around;
                align-items: center;

                .vertical_line {
                    width: 1px;
                    height: 16px;
                    background: #EBEBEB;
                }
            }

        }
    }

    .layout-header-header {
        box-sizing: border-box;
        margin: 24px 16px;
        margin-top: 0;
    }

    .site-fence {
        background: #fff;

        .pb0 {
            padding-bottom: 0;
        }

        .mb16 {
            margin-bottom: 16px;
        }

        .flex-center-between {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .flex-right-area {
            margin-top: -12px;
        }
    }
</style>
